import { filter } from 'lodash';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import AICompanionLearnMoreDialog from '@/components/full-comparison-table/ai-companion-learn-more-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { unlockProLicenseCount, unlockBizLicenseCount } from '@/common/constants';

const ComparisonTypeMap = {
	PHONE: 'phone',
	CORE_FEATURES: 'coreFeatures',
	MEETINGS: 'meetings',
	TEAM_CHAT: 'teamChat',
	INTEGRATIONS: 'integrations',
	FUN: 'fun',
	SECURITY: 'security',
	SUPPORT: 'support',
  };
export default {
	created(){
		let me = this;
		const coreFeaturesItem = [
		{
			feature: this.$t('meetings.fullPlanItem2'),
			tooltip: this.$t('meetings.fullPlanItem2Tip'),
			isString: true,
			basic: '1',
			basicPlus: '1',
			pro: unlockProLicenseCount ? '1-99' : '1-9',
			proPlus: '1-99',
			business: unlockBizLicenseCount ? '1-99' : '10-99',
			businessPlus: unlockBizLicenseCount ? '1-99' : '10-99',
			enterprise: '> 250',
		},
		{
			feature: this.$t('phone.fullPlanItem30'),
			tooltip:
			this.$t('simplifiedVideoConferencingAndMessagingAcrossAnyDevice'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem5'),
			tooltip: this.$t('meetings.fullPlanItem5Tip'),
			isString: true,
			basic: this.$t('meetings.fullPlanItem5_basic'),
			basicPlus: this.$t('one.basicPlusFullPlanItem1'),
			pro: this.$t('meetings.fullPlanItem5_pro'),
			proPlus: this.$t('meetings.fullPlanItem5_pro'),
			business: this.$t('meetings.fullPlanItem5_biz'),
			businessPlus: this.$t('meetings.fullPlanItem5_biz'),
			enterprise: this.$t('meetings.fullPlanItem5_ent'),
		},
		{
			feature: this.$t('meetings.fullPlanItem1'),
			tooltip: this.$t('meetings.fullPlanItem1Tip'),
			isString: true,
			basic: 100,
			basicPlus: 100,
			pro: 100,
			proPlus: 100,
			business: 300,
			businessPlus: 300,
			enterprise: this.$t('meetings.fullPlanItem1_ent'),
		},
		{
			feature: this.$t('meetings.fullPlanItem7'),
			tooltip: this.$t('meetings.fullPlanItem7Tip'),
			isString: true,
			basic: this.$t('meetings.fullPlanItem7_basic'),
			basicPlus: this.$t('meetings.fullPlanItem7_basic'),
			pro: this.$t('meetings.fullPlanItem7_pro'),
			proPlus: this.$t('meetings.fullPlanItem7_pro'),
			business: this.$t('meetings.fullPlanItem7_pro'),
			businessPlus: this.$t('meetings.fullPlanItem7_biz'),
			enterprise: this.$t('meetings.fullPlanItem7_ent'),
		},
		{
			feature: this.$t('one.messaging'),
			tooltip: this.$t('meetings.fullPlanItem16Tip'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem51'),
			isString: true,
			basic: '3',
			basicPlus: '3',
			pro: '3',
			proPlus: '3',
			business: this.$t('meetings.unlimited'),
			businessPlus: this.$t('meetings.unlimited'),
			enterprise: this.$t('meetings.unlimited'),
		},
		{
			feature: this.$t('meetings.fullPlanItem_EssentialApp'),
			isNew: false,
			link: {
			text: this.$t('common.learnMore'),
			style: {
				fontSize: '12px',
				fontWeight: 700,
				color: '#0B5CFF',
			},
			ariaLabel: 'Learn more about Essential Apps',
			async callback () {
				await me.essentialAppLearnMoreDialogService.confirm();
			}
			},
			isString: true,
			basic: false,
			basicPlus: false,
			pro: this.$t('meetings.fullPlanItem_EssentialAppText'),
			proPlus: this.$t('meetings.fullPlanItem_EssentialAppText'),
			business: this.$t('meetings.fullPlanItem_EssentialAppText'),
			businessPlus: this.$t('meetings.fullPlanItem_EssentialAppText'),
			enterprise: false,
		},
		{
			feature: this.$t('mail'),
			tooltip: this.$t('zoomMailAndCalendarInTheZoomApp'),
			basic: true,
			basicPlus: true,
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			shouldHide: !['US', 'CA'].includes(this.currentCountry),
			feature: this.$t('mailService'),
			tooltip: this.$t('emailServiceWithFullTimeEndToEnd'),
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('customMailDomain'),
			tooltip: this.$t('customMailDomainWithMailService'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('calendarClient'),
			tooltip: this.$t('scheduleAndJoinMeetings'),
			basic: true,
			basicPlus: true,
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('aiCompanion'),
			tooltip: '',
			business: true,
			businessPlus: true,
			enterprise: true,
			pro: true,
			proPlus: true,
			isNew: true,
			link: {
			text: this.$t('common.learnMore'),
			style: {
				fontSize: '12px',
				fontWeight: 700,
				color: '#0B5CFF'
			},
			ariaLabel: 'Learn more about AI Companion',
			async callback () {
				await me.aiCompanionLearnMoreDialogService.confirm();
			}
			},
		},
		{
			shouldHide: !['US', 'CA'].includes(this.currentCountry),
			feature: this.$t('calendarService'),
			tooltip: this.$t('meetingSchedulingAndAppointment'),
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('marketing.new_pricing.clips'),
			isNew: true,
			isString: true,
			tooltip: this.$t('allPlansClipsCoreFeatureToolTip'),
			basic: `${this.freeZoomClipsQuantity} ${this.$t('included')}`,
			pro: this.$t('meetings.unlimited'),
			proPlus: this.$t('meetings.unlimited'),
			business: this.$t('meetings.unlimited'),
			businessPlus: this.$t('meetings.unlimited'),
			enterprise: this.$t('meetings.unlimited'),
		},
		{
			feature: this.$t('marketing.new_pricing.notes'),
			isNew: true,
			tooltip: this.$t('allPlansNotesCoreFeatureToolTip'),
			basic: true,
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('common.phoneTab'),
      proPlus: true,
			businessPlus: true,
		},
		{
			feature: this.$t('automatedMeetingsCaptions'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('translatedCaptions-0'),
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('workspaceReservation'),
			businessPlus: true,
		},
    {
      feature: this.$t('billing.visitor_management.title'),
      businessPlus: true,
      link: {
        text: this.$t('common.learnMore'),
        style: {
          fontSize: '12px',
          fontWeight: 700,
          color: '#0B5CFF'
        },
        ariaLabel: 'Learn more about Visitor Management',
        async callback () {
          await me.visitorManagementLearnMoreDialogService.confirm();
        }
      },
    },
		{
			feature: 'Zoom Scheduler',
			isString: true,
			tooltip: 'Zoom Scheduler optimizes scheduling by sharing your availability for others to conveniently book appointments. Works seamlessly with your Zoom Meetings and Zoom Mail and Calendar, and integrates with Google and Microsoft 365.',
			business: true,
			businessPlus: true,
			enterprise: '*Included in Enterprise Plus',
		},
		{
			feature: this.$t('accessAcrossAnyDevice'),
			basic: true,
			basicPlus: true,
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		];
		const meetingsItem = [
		{
			feature: this.$t('meetings.fullPlanItem1'),
			tooltip: this.$t('meetings.fullPlanItem1Tip'),
			isString: true,
			basic: 100,
			basicPlus: 100,
			pro: 100,
      proPlus: 100,
			business: 300,
			businessPlus: 300,
			enterprise: this.$t('meetings.fullPlanItem1_ent'),
		},
		{
			feature: this.$t('meetings.fullPlanItem4'),
			basic: true,
			basicPlus: true,
			pro: true,
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem5'),
			tooltip: this.$t('meetings.fullPlanItem5Tip'),
			isString: true,
			basic: this.$t('meetings.fullPlanItem5_basic'),
			basicPlus: this.$t('one.basicPlusFullPlanItem1'),
			pro: this.$t('meetings.fullPlanItem5_pro'),
			proPlus: this.$t('meetings.fullPlanItem5_pro'),
			business: this.$t('meetings.fullPlanItem5_biz'),
			businessPlus: this.$t('meetings.fullPlanItem5_biz'),
			enterprise: this.$t('meetings.fullPlanItem5_ent'),
		},
		{
			feature: this.$t('meetings.fullPlanItem7'),
			tooltip: this.$t('meetings.fullPlanItem7Tip'),
			isString: true,
			basic: this.$t('meetings.fullPlanItem7_basic'),
			basicPlus: this.$t('meetings.fullPlanItem7_basic'),
			pro: this.$t('meetings.fullPlanItem7_pro'),
			proPlus: this.$t('meetings.fullPlanItem7_pro'),
			business: this.$t('meetings.fullPlanItem7_pro'),
			businessPlus: this.$t('meetings.fullPlanItem7_biz'),
			enterprise: this.$t('meetings.fullPlanItem7_ent'),
		},
		{
			feature: this.$t('meetings.fullPlanItem9'),
			tooltip: this.$t('meetings.fullPlanItem9Tip'),
			isString: true,
			pro: this.$t('meetings.fullPlanItem9_pro'),
			proPlus: this.$t('meetings.fullPlanItem9_pro'),
			business: this.$t('meetings.fullPlanItem9_biz'),
			businessPlus: this.$t('meetings.fullPlanItem9_biz'),
			enterprise: this.$t('meetings.fullPlanItem9_ent'),
		},
		{
			feature: this.$t('meetings.fullPlanItem_EssentialApp'),
			isNew: false,
			link: {
			text: this.$t('common.learnMore'),
			style: {
				fontSize: '12px',
				fontWeight: 700,
				color: '#0B5CFF',
			},
			ariaLabel: 'Learn more about Essential Apps',
			async callback () {
				await me.essentialAppLearnMoreDialogService.confirm();
			}
			},
			isString: true,
			basic: false,
			basicPlus: false,
			pro: this.$t('meetings.fullPlanItem_EssentialAppText'),
			proPlus: this.$t('meetings.fullPlanItem_EssentialAppText'),
			business: this.$t('meetings.fullPlanItem_EssentialAppText'),
			businessPlus: this.$t('meetings.fullPlanItem_EssentialAppText'),
			enterprise: false,
		},
		{
			feature: this.$t('meetings.fullPlanItem11'),
			tooltip: this.$t('meetings.fullPlanItem11Tip'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem12'),
			tooltip: this.$t('meetings.fullPlanItem12Tip'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem14'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem15'),
			tooltip: this.$t('meetings.fullPlanItem15Tip'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem17'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem18'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem19'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem21'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem29'),
			tooltip: this.$t('meetings.fullPlanItem29Tip'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem41'),
			isNew: true,
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem61'),
			tooltip: this.$t('meetings.fullPlanItem61Tip'),
			isNew: true,
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem62'),
			tooltip: this.$t('meetings.fullPlanItem62Tip'),
			isNew: true,
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanNewItem1'),
			tooltip: this.$t('meetings.fullPlanNewItem1Tip'),
			isNew: true,
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanNewItem2'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanNewItem3'),
			tooltip: this.$t('meetings.fullPlanNewItem3Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem24'),
			tooltip: this.$t('meetings.fullPlanItem24Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem25'),
			tooltip: this.$t('meetings.fullPlanItem25Tip'),
			isString: true,
			pro: this.$t('meetings.fullPlanItem25_pro'),
      proPlus: this.$t('meetings.fullPlanItem25_pro'),
			business: this.$t('meetings.fullPlanItem25_pro'),
			businessPlus: this.$t('meetings.fullPlanItem25_biz'),
			enterprise: this.$t('meetings.fullPlanItem25_biz'),
		},
		{
			feature: this.$t('meetings.fullPlanItem26'),
			tooltip: this.$t('meetings.fullPlanItem26Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem27'),
			tooltip: this.$t('meetings.fullPlanItem27Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem28'),
			tooltip: this.$t('meetings.fullPlanItem28Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem30'),
			tooltip: this.$t('meetings.fullPlanItem30Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('one.autoCaptions'),
			isNew: true,
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
			desc: this.$t('multiLanguage'),
		},
		{
			feature: this.$t('meetings.fullPlanItem31'),
			tooltip: this.$t('meetings.fullPlanItem31Tip'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem32'),
			tooltip: this.$t('meetings.fullPlanItem32Tip'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem33'),
			tooltip: this.$t('meetings.fullPlanItem33Tip'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem34'),
			tooltip: this.$t('meetings.fullPlanItem34Tip'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem35'),
			tooltip: this.$t('meetings.fullPlanItem35Tip'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem37'),
			tooltip: this.$t('meetings.fullPlanItem37Tip'),
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanItem39'),
			tooltip: this.$t('meetings.fullPlanItem39Tip'),
			enterprise: true,
		},
		{
			feature: this.$t('meetings.fullPlanNewItem4'),
			enterprise: true,
			enterpriseDesc: this.$t('enterprisePlusIncludesZoomSessions_1000')
		},
		{
			feature: this.$t('one.translatedCations'),
			businessPlus: true,
			enterprise: this.$t('one.entPlus'),
		},
		{
			feature: this.$t('customMailDomain'),
			tooltip: this.$t('customMailDomainWithMailService'),
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		];
		const teamChatItem = [
		{
			feature: this.$t('directChannelOrGroupChat'),
			tooltip:
			this.$t('easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('messageAndFileHistory'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('findPeopeChannelsAndFilesInSearch'),
			tooltip:
			this.$t('quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('applicationIntegrations'),
			tooltip:
			this.$t('boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('secureFileSharing'),
			tooltip: this.$t('enhanceCollaborationWithSeamlessFileSharing'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('persistentMeetingChat'),
			tooltip:
			this.$t('neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('cloudStorage'),
			tooltip:
			this.$t('backChannelsToTheZoomCloudOrAThirdPartyStorageProvider'),
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		];
		const integrationsItem = [
			{
				feature: 'Microsoft',
				basic: true,
				basicPlus: true,
				pro: true,
        proPlus: true,
				business: true,
				businessPlus: true,
				enterprise: true,
			},
			{
				feature: 'Google',
				basic: true,
				basicPlus: true,
				pro: true,
        proPlus: true,
				business: true,
				businessPlus: true,
				enterprise: true,
			},
			{
				feature: 'Salesforce',
				basic: true,
				basicPlus: true,
				pro: true,
        proPlus: true,
				business: true,
				businessPlus: true,
				enterprise: true,
			},
			{
				feature: 'ServiceNow',
				basic: true,
				basicPlus: true,
				pro: true,
        proPlus: true,
				business: true,
				businessPlus: true,
				enterprise: true,
			},
			{
				feature: 'Hubspot',
				basic: true,
				basicPlus: true,
				pro: true,
        proPlus: true,
				business: true,
				businessPlus: true,
				enterprise: true,
			}
		];
		const funItem = [
		{
			feature: this.$t('avatars'),
			tooltip:
			this.$t('customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('inMeetingReactions'),
			tooltip:
			this.$t('showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('virtualBackgrounds'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('videoFilters'),
			tooltip:
			this.$t('injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('inMeetingPollsAndQuizzes'),
			tooltip:
			this.$t('createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings'),
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('liveStreamingAcrossPlatforms'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('appearanceTouchUp'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('originalSoundForMusicians'),
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		];
		const securityItem = [
		{
			feature: this.$t('endToEndEncryptionForZoomMeetings'),
			tooltip: this.$t(
			'whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings'
			),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('zoomCustomerManagedKey'),
			tooltip: this.$t('bringYourOwnEncryptionKeysToProtectZoomDataAtRest'),
			enterprise: this.$t('one.entPlus'),
		},
		{
			feature: this.$t('enterpriseGradeSecurityFeatures'),
			tooltip: this.$t('256BitAesGcmEncryptionForRealTimeContent'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		];
		const phoneItem = [
      {
        feature: this.$t('phone.fullPlanItem40'),
        tooltip: this.$t('phone.fullPlanItem40Tip'),
        proPlus: false,
        businessPlus: true,
        enterprise: true,
      },
		{
			feature: this.$t('phone.fullPlanItem1'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem2'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem3'),
      proPlus: true,
			businessPlus: true,
		},
		{
			feature: this.$t('phone.fullPlanItem4'),
			tooltip: this.$t('phone.fullPlanItem4Tip'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem5'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem6'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem7'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem8'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem9'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem10'),
			tooltip: this.$t('phone.fullPlanItem10Tip'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem11'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem12'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem13'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem14'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem15'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem16'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem17'),
			tooltip: this.$t('phone.fullPlanItem17Tip'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem18'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem19'),
			tooltip: this.$t('phone.fullPlanItem19Tip'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem20'),
			tooltip: this.$t('phone.fullPlanItem20Tip'),
			pdf: true,
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem21'),
			tooltip: this.$t('phone.fullPlanItem21Tip'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem22'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem23'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem24'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('endToEndEncryptionForZoomPhone'),
			tooltip: this.$t('whenEnabledForZoomPhoneEndToEndEncryptionE2ee'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem43'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem44'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem46'),
      proPlus: false,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem47'),
			tooltip: this.$t('phone.fullPlanItem47Tip'),
      proPlus: false,
			businessPlus: true,
			enterprise: true,
		},
		{
      isString: true,
			feature: this.$t('billing.pbx.phone_support_24_7_live_chat'),
			tooltip: this.$t('availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans'),
      proPlus: this.$t('billing.zone_pro_plus.pro_plus_phone_features'),
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem49'),
			tooltip: this.$t('phone.fullPlanItem49Tip'),
      proPlus: false,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('phone.fullPlanItem50'),
      proPlus: false,
			businessPlus: true,
			enterprise: true,
		},
		{
			suppurtCountry: 'us',
			feature: this.$t('phone.fullPlanSms'),
			tooltip: this.$t('phone.fullPlanSmsTip'),
      proPlus: true,
			businessPlus: true,
			enterprise: true,
		},
		];
		const supportItem = [
		{
			feature: this.$t('meetings.fullPlanItem6'),
			tooltip: this.$t('meetings.fullPlanItem6Tip'),
			isString: true,
			basic: this.$t('meetings.fullPlanItem6_basic'),
			basicPlus: this.$t('meetings.fullPlanItem6_basic'),
			pro: this.$t('meetings.fullPlanItem6_pro'),
      proPlus: this.$t('meetings.fullPlanItem6_pro'),
			business: this.$t('meetings.fullPlanItem6_biz'),
			businessPlus: this.$t('meetings.fullPlanItem6_biz'),
			enterprise: this.$t('meetings.fullPlanItem6_ent'),
		},
		{
			feature: this.$t('knowledgeBase'),
			tooltip:
			this.$t('troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('zoomCommunity'),
			tooltip:
			this.$t('aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('chatbot'),
			tooltip:
			this.$t('getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot'),
			basic: true,
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('submitWebTickets'),
			basicPlus: true,
			pro: true,
      proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('liveChatSupport'),
			isString: true,
			basicPlus: true,
			pro: this.$t('subscriptionPlansGreaterThan_50UsdMonth'),
			proPlus: true,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('livePhoneSupport'),
			isString: true,
			tooltip: 'This feature is only available for admin',
			basicPlus: true,
			pro: this.$t('subscriptionPlansGreaterThan_200UsdMonth'),
			proPlus: false,
			business: true,
			businessPlus: true,
			enterprise: true,
		},
		{
			feature: this.$t('meetWithAgentOnVideo'),
			isString: true,
			tooltip: 'This feature is only available for admin',
			business: this.$t('subscriptionPlansGreaterThan_200UsdMonth'),
			businessPlus: this.$t('subscriptionPlansGreaterThan_200UsdMonth'),
			enterprise: this.$t('subscriptionPlansGreaterThan_200UsdMonth'),
		},
		];

		this.coreFeaturesItem = filter(coreFeaturesItem, (item) => {
		return item.shouldHide !== true;
		});
		this.tableData.coreFeatures = this.coreFeaturesItem;
		this.meetingsItem = filter(meetingsItem, (item) => {
		return item.shouldHide !== true;
		});
		this.tableData.meetings = this.meetingsItem;
		this.securityItem = filter(securityItem, (item) => {
		return item.shouldHide !== true;
		});
		this.tableData.security = this.securityItem;

		this.tableData.teamChat = teamChatItem;
		this.teamChatItem = teamChatItem;
		this.tableData.integrations = integrationsItem;
		this.integrationsItem = integrationsItem;
		this.tableData.fun = funItem;
		this.funItem = funItem;
		this.tableData.phone = phoneItem;
		this.phoneItem = phoneItem;
		this.tableData.support = supportItem;
		this.supportItem = supportItem;

		this.updateTableData(this.currentCountry);
	},
	computed:{
		treeData () {
			const mapItemKey = (data, pid) =>
				data.map((item, idx) => ({
				...item,
				id: `${pid}_${idx}`,
				}));
			return [
				{
				feature: 'Core Features',
				id: ComparisonTypeMap.CORE_FEATURES,
				subTitle: true,
				children: mapItemKey(
					this.tableData.coreFeatures || [],
					ComparisonTypeMap.CORE_FEATURES
				),
				},
				{
				feature: 'Meetings',
				id: ComparisonTypeMap.MEETINGS,
				subTitle: true,
				children: mapItemKey(
					this.tableData.meetings || [],
					ComparisonTypeMap.MEETINGS
				),
				},
				{
				feature: 'Team Chat',
				id: ComparisonTypeMap.TEAM_CHAT,
				subTitle: true,
				children: mapItemKey(
					this.tableData.teamChat || [],
					ComparisonTypeMap.TEAM_CHAT
				),
				},
				{
					feature: 'Integrations',
					id: ComparisonTypeMap.INTEGRATIONS,
					subTitle: true,
					children: mapItemKey(
						this.tableData.integrations || [],
						ComparisonTypeMap.INTEGRATIONS
					),
				},
				{
				feature: 'Engagement',
				id: ComparisonTypeMap.FUN,
				subTitle: true,
				children: mapItemKey(this.tableData.fun || [], ComparisonTypeMap.FUN),
				},
				{
				feature: 'Security',
				id: ComparisonTypeMap.SECURITY,
				subTitle: true,
				children: mapItemKey(
					this.tableData.security || [],
					ComparisonTypeMap.SECURITY
				),
				},
				{
				feature: 'Phone',
				id: ComparisonTypeMap.PHONE,
				subTitle: true,
				children: mapItemKey(
					[...this.tableData.phone] || [],
					ComparisonTypeMap.PHONE
				),
				},
				{
				feature: 'Support',
				id: ComparisonTypeMap.SUPPORT,
				subTitle: true,
				children: mapItemKey(
					this.tableData.support || [],
					ComparisonTypeMap.SUPPORT
				),
				},
			];
		},
		currentCountry(){
			return window.newBillingConfig.currentCountry || 'US'
		},
		freeZoomClipsQuantity(){
			return window.newBillingConfig.freeZoomClipsQuantity || '5'
		}
	},
	data(){
		return{
			essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog),
			aiCompanionLearnMoreDialogService: new ServiceConfirm(AICompanionLearnMoreDialog),
		}
	}
};
